export default __webpack_public_path__ + "static/mainBgImageHAICSMC-947077204882a1d05da6b1728536a4ee.jpeg";